import React from 'react'
import { Button } from '../../../ui/button'
import { Card, CardContent } from '../../../ui/card'
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from '../../../ui/table'
import { filasPorJugador, prendasPresentes } from '../../../../lib/uniformesPorJugador'

// La vista del dia que se mide al equipo: se llama al jugador UNA vez y se capturan
// todas sus tallas de un jalon. La otra vista (por prenda) es la de repartir.
//
// No entrega: aqui solo se capturan tallas. Entregar exige mirar el pedido, la
// recepcion y el pago de cada pieza, y eso pide una fila por prenda -- que es
// exactamente lo que hace la vista por prenda.
const TablaPorJugador = ({ entregas = [], jugadorById = {}, prendas = [], guardando, onCapturarTalla }) => {
  const filas = filasPorJugador(entregas, jugadorById)
  const columnas = prendasPresentes(entregas, prendas)

  if (!filas.length) {
    return (
      <Card>
        <CardContent className="py-12 text-center text-muted-foreground">
          Ningún jugador para medir con los filtros actuales.
        </CardContent>
      </Card>
    )
  }

  const Tallas = ({ fila, prenda }) => {
    const e = fila.porPrenda[prenda.id]
    if (!e) return <span className="text-xs text-muted-foreground">—</span>
    const tallas = prenda.tallas || []
    if (!tallas.length) {
      return <span className="text-[11px] text-muted-foreground">Sin tallas configuradas</span>
    }
    return (
      <div className="flex flex-wrap items-center gap-1">
        {tallas.map((t) => (
          <Button
            key={t}
            size="sm"
            variant={e.talla === t ? 'default' : 'outline'}
            className="h-7 min-w-9 px-2 text-xs"
            aria-pressed={e.talla === t}
            aria-label={`${prenda.nombre} talla ${t} para ${fila.jugador.nombre_completo}`}
            disabled={guardando?.has(e.id)}
            onClick={() => onCapturarTalla(e, fila.jugador, t)}
          >
            {t}
          </Button>
        ))}
        {guardando?.has(e.id) && (
          <span className="text-[11px] text-muted-foreground">Guardando...</span>
        )}
      </div>
    )
  }

  return (
    <>
      {/* Movil: una tarjeta por jugador. Una tabla de 4+ columnas se recorta en
          silencio en telefono (ux-rules §11). */}
      <div className="space-y-3 sm:hidden">
        {filas.map((fila) => (
          <Card key={fila.jugador.id}>
            <CardContent className="py-3">
              <div className="flex items-baseline justify-between gap-2">
                <span className="text-sm font-medium">{fila.jugador.nombre_completo}</span>
                <span className={`text-[11px] tabular-nums ${fila.sinTalla ? 'text-amber-700' : 'text-green-600'}`}>
                  {fila.sinTalla ? `Faltan ${fila.sinTalla}` : 'Completo'}
                </span>
              </div>
              <div className="mt-2 space-y-2">
                {columnas.map((p) => (
                  <div key={p.id}>
                    <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{p.nombre}</p>
                    <div className="mt-1"><Tallas fila={fila} prenda={p} /></div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Escritorio: un renglon por jugador, una columna por prenda */}
      <Card className="hidden sm:block">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Jugador</TableHead>
                {columnas.map((p) => <TableHead key={p.id}>{p.nombre}</TableHead>)}
                <TableHead className="text-right">Faltan</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filas.map((fila) => (
                <TableRow key={fila.jugador.id}>
                  <TableCell className="font-medium">{fila.jugador.nombre_completo}</TableCell>
                  {columnas.map((p) => (
                    <TableCell key={p.id}><Tallas fila={fila} prenda={p} /></TableCell>
                  ))}
                  <TableCell className="text-right tabular-nums">
                    {fila.sinTalla > 0
                      ? <span className="text-amber-700">{fila.sinTalla}</span>
                      : <span className="text-green-600">✓</span>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </>
  )
}

export default TablaPorJugador
